import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  fetchData, handleFilter } from "../../utils/data";
import {  BookingTrip } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";

export const fetchAllBookTrips = createAsyncThunk("get/AllBookTrips", async () => {
    const data = await fetchData(`BookTrip/getAllBookTrips?lang=${lang}`, true);
    return data;
});

export const filterAdminTrips = createAsyncThunk("post/filterAdminTrips", async (tripData: any) => {
    const response = await handleFilter(tripData, `BookTrip/filterBooks?lang=${lang}`, "POST");
    return response;
});
interface bookingState {
    tripBookings: BookingTrip[];
    filterBookingResult:BookingTrip[];
    loading: boolean;
    error: string;
}

const initialState: bookingState = {
    tripBookings:[],
    filterBookingResult:[],
    loading: false,
    error: ""
};

const adminTripBookingSlice = createSlice({
    name: "adminTripBookingSlice",
    initialState,
    reducers: {
  clearFilterResults: (state) => {
    state.filterBookingResult = [];
  },
},
    extraReducers: (builder) => {
        builder
            // Fetch

            .addCase(fetchAllBookTrips.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchAllBookTrips.fulfilled, (state, action) => {
                state.loading = false;
                state.tripBookings= action.payload;
            })
            .addCase(filterAdminTrips.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(filterAdminTrips.fulfilled, (state, action) => {
                state.loading = false;
                state.filterBookingResult= action.payload.data;
            })


    }
});
export const { clearFilterResults } = adminTripBookingSlice.actions;
export default adminTripBookingSlice.reducer;
